import { FC } from 'react';
import { FormControl, MenuItem, Select, styled } from '@mui/material';
import { toString } from 'lodash';
import theme from 'theme';
import { FundSelectorProps } from './FundSelector.props';

const COLUMN_DRAG_HANDLE_WIDTH = 20;

const StyledSelect = styled(Select)(() => ({
  '&.Mui-focused .MuiSelect-select': {
    background: 'transparent !important',
  },
  '& .MuiList-root': {
    padding: 0,
  },
  '& .MuiSelect-select': {
    background: 'transparent',
    color: `${theme.palette.primary[700]} !important`,
    fontWeight: 700,
    minWidth: 0,
    overflow: 'hidden',
    paddingLeft: `calc(${theme.spacing(1)} + ${COLUMN_DRAG_HANDLE_WIDTH}px)`,
    paddingRight: `${theme.spacing(4)} !important`,
    paddingTop: theme.spacing(0.75),
    textAlign: 'right',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .MuiSelect-icon': {
    fill: `${theme.palette.primary[700]} !important`,
    marginTop: theme.spacing(0.25),
  },
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  '&.MuiMenuItem-root': {
    color: theme.palette.primary[700],
    fontSize: '14px',
    fontWeight: 700,
    justifyContent: 'flex-end',
    lineHeight: '1.2', // Better line spacing for wrapped text
    minHeight: theme.spacing(2.5), // Ensure minimum height for readability
    overflow: 'visible',
    padding: theme.spacing(1, 1.5),
    textAlign: 'right',
    whiteSpace: 'normal', // Allow wrapping
    wordWrap: 'break-word', // Break long words if needed
  },

  '&:hover': {
    backgroundColor: '#DEEBFF',
  },

  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: '#2684FF',
    color: theme.palette.common.white,
  },
}));

const FundSelector: FC<FundSelectorProps> = props => {
  const { handleOnChange, options, value } = props;

  return (
    <FormControl fullWidth sx={{ minWidth: 0, position: 'relative' }}>
      <StyledSelect
        MenuProps={{
          disablePortal: true,
          PaperProps: {
            sx: {
              borderRadius: 0,
              boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1)',
              maxHeight: theme.spacing(30),
              ml: 2.25,
              top: `${theme.spacing(2.125)} !important`,
              width: theme.spacing(22.875),
            },
          },
        }}
        disableUnderline
        onChange={e => handleOnChange(toString(e.target.value))}
        SelectDisplayProps={{ title: value }}
        value={value}
        variant="standard">
        {options.map(option => (
          <StyledMenuItem key={option} value={option}>
            {option}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default FundSelector;
